import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { lagerInventurRoutes } from '@softapps/mde/inventur';
import { retourenRoutes } from '@softapps/mde/retouren';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      // MDE
      ...bestellvorschlagRoutes,
      ...bestellerfassungRoutes,
      ...etikettendruckRoutes,
      ...lagerInventurRoutes,
      ...retourenRoutes,
      ...warenverprobungRoutes,
      ...artikelInfoRoutes
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [ ...loginRoutes, ...passwordRoutes, ...settingsRoutes],
  },
];
